import Form from "@/views/App/Portal/SocioTherapyCoaching/FirstInterview/Form.vue";
import List from "@/views/App/Portal/SocioTherapyCoaching/Protocol/List.vue";
import FirstAppointmentList from "@/views/App/Portal/SocioTherapyCoaching/InvitationToFirstAppointment/List.vue";
import FinalInterviewForm from "@/views/App/Portal/SocioTherapyCoaching/FinalInterview/Form.vue";
import DocumentsForm from "@/views/App/Portal/SocioTherapyCoaching/IntroductoryDocuments/Form.vue";
import MeetingList from "@/views/App/Portal/SocioTherapyCoaching/MeetingList/List.vue";
import InterimReportList from "@/views/App/Portal/SocioTherapyCoaching/InterimReport/List.vue";

const routesPortalSocioTherapyCoaching = [
    {
        path: 'first-interview/:id',
        name: 'socioTherapyCoachingFirstInterviewForm',
        component: Form
    },
    {
        path: 'protocol-list/:id',
        name: 'socioTherapyCoachingCoachingProtocolList',
        component: List
    },
    {
        path: 'invitation-to-first-appointment-list/:id',
        name: 'socioTherapyCoachingCoachingInvitationToFirstAppointmentList',
        component: FirstAppointmentList
    },
    {
        path: 'final-interview-form/:id',
        name: 'socioTherapyCoachingCoachingFinalInterviewForm',
        component: FinalInterviewForm
    },
    {
        path: 'interim-report-list/:id',
        name: 'socioTherapyCoachingCoachingInterimReportList',
        component: InterimReportList
    },
    {
        path: 'meeting-list/:id',
        name: 'socioTherapyCoachingCoachingMeetingList',
        component: MeetingList
    }
];

export default routesPortalSocioTherapyCoaching;